import HelloPage from "../Components/Hello/Hello";
import PageWrapper from "../Components/PageWrapper/PageWrapper";

export default function Home() {
  return (
    <PageWrapper>
      <HelloPage />
    </PageWrapper>
  );
}
